<template lang="">
  <div>
    <div class="grid styled-form">
      <div class="col-12 lg:col-9">
        <div class="header">
          <div class="profile-avatar">
            <Avatar
              :image="avatar.url"
              class="mr-2"
              size="xlarge"
              shape="circle"
            />
          </div>
        </div>
        <div class="user-info">
          <h1>
            {{ $store.getters["profile/name_backup"] }}
            {{ $store.getters["profile/surname_backup"] }}
          </h1>
          <!--
              <h3>Marketing Manager</h3>
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Doloribus magni in est ea obcaecati soluta nostrum consectetur facere error</p>
          -->
        </div>

        <TabView v-model:activeIndex="active">
          <TabPanel :header="$t('profile.tab1_personal_infos')">
            <form autocomplete="off" class="form-profile">
              <div class="formgrid grid">
                <div class="field col">
                  <label class="label-input-rounded" for="name">{{
                    $t("profile.name")
                  }}</label
                  ><br />
                  <input
                    autocomplete="off"
                    v-model="v$.name.$model"
                    :class="{ invalid: v$.name.$invalid && v$.name.$dirty }"
                    class="inputtext component input-rounded"
                    id="name"
                    type="text"
                  />
                  <span
                    v-if="v$.name.$invalid && v$.name.$dirty"
                    class="error"
                    >{{ $t("form.required_field") }}</span
                  >
                </div>
                <div class="field col">
                  <label class="label-input-rounded" for="surname">{{
                    $t("profile.surname")
                  }}</label
                  ><br />
                  <input
                    v-model="v$.surname.$model"
                    :class="{
                      invalid: v$.surname.$invalid && v$.surname.$dirty,
                    }"
                    class="inputtext component input-rounded"
                    id="surname"
                    type="text"
                  />
                  <span
                    v-if="v$.surname.$invalid && v$.surname.$dirty"
                    class="error"
                    >{{ $t("form.required_field") }}</span
                  >
                </div>
              </div>
              <div class="formgrid grid">
                <div class="field col">
                  <label class="label-input-rounded" for="email">Email</label
                  ><br />
                  <input
                    autocomplete="off"
                    v-model="v$.email.$model"
                    :class="{ invalid: v$.email.$invalid && v$.email.$dirty }"
                    class="inputtext component input-rounded"
                    id="email"
                    type="text"
                  />
                  <span
                    v-if="v$.email.required.$invalid && v$.email.$dirty"
                    class="error"
                    >{{ $t("form.required_field") }}</span
                  >

                  <span
                    v-if="v$.email.email.$invalid && v$.email.$dirty"
                    class="error"
                    >{{ $t("form.invalid_format") }}</span
                  >
                </div>
                <div class="field col">
                  <label class="label-input-rounded" for="address_country">{{
                    $t("profile.address_country")
                  }}</label
                  ><br />
                  <input
                    autocomplete="off"
                    v-model="v$.address_country.$model"
                    :class="{
                      invalid:
                        v$.address_country.$invalid &&
                        v$.address_country.$dirty,
                    }"
                    class="inputtext component input-rounded"
                    id="address_country"
                    type="text"
                  />
                  <span
                    v-if="
                      v$.address_country.$invalid && v$.address_country.$dirty
                    "
                    class="error"
                    >{{ $t("form.required_field") }}</span
                  >
                </div>
              </div>
            </form>
            <p>{{ $t("profile.family_members") }}</p>
            <div class="family-members">
              <div
                v-for="m of $store.getters['profile/family_members']"
                :key="m.id"
                class="grid "
              >
                <div class="col-5 family-member">
                  <div class="grid">
                    <div class="col">
                      <p class="small">
                        {{ m.name }} {{ m.surname }} &nbsp;
                        <i
                          @click="editFamilyMember(m.id)"
                          class="pi pi-pencil pointer"
                          style="float: right; margin-top: 5px;"
                        ></i>

                        <i
                          style="float: right; margin-right: 10px;margin-top: 5px;"
                          @click="removeFamilyMember(m.id)"
                          class="pi pi-trash pointer"
                        ></i>
                        <br />
                        <span class="smaller">{{ m.relation }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5 grid">
              <div class="col text-right">
                <Button
                  type="button"
                  class="button-text p-button-secondary rectangular"
                  @click="addFamilyMember()"
                >
                  <span class="ml-2 p-button-label">{{
                    $t("profile.add_family_member")
                  }}</span>
                  <div class="icon small">
                    <i class="pi pi-plus"></i>
                  </div>
                </Button>
                <Button @click="save()" :label="$t('form.submit_label')" />
              </div>
            </div>
          </TabPanel>
          <TabPanel :header="$t('profile.tab2_info_addon')">
            <ProfiloIntolleranze></ProfiloIntolleranze>
          </TabPanel>
          <TabPanel :header="$t('profile.tab3_settings')"> </TabPanel>
        </TabView>
      </div>
      <div class="col-12 lg:col-3">
        <ProfileSidebox />
      </div>
    </div>
    <Dialog
      :header="
        $store.getters['familyMember/id'] == ''
          ? $t('family_member.add_title')
          : $t('family_member.edit_title')
      "
      :modal="true"
      v-model:visible="displayFamily"
    >
      <FamilyMemberForm @familyDone="displayFamily = !displayFamily" />
    </Dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { required, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ProfileSidebox from "../components/Profile/ProfileSidebox";
import ProfiloIntolleranze from "../components/Profile/ProfiloIntolleranze";
import FamilyMemberForm from "../components/Profile/FamilyMemberForm";
import { nextTick } from "@vue/runtime-core";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      ingredients: [
        { name: "Pasta", code: "PASTA" },
        { name: "Riso", code: "RISO" },
        { name: "Melanzane", code: "MELANZANE" },
      ],
      allergyFilteredIngredients: [],
      hobbies: [],
      displayFamily: false,
      active: 0,
    };
  },
  validations() {
    return {
      name: {
        required,
      },
      surname: {
        required,
      },
      email: {
        required,
        email,
      },
      address_country: {
        required,
      },
    };
  },
  mounted() {
    this.$store.dispatch(
      "achievements/fetch",
      this.$store.getters["userdata/getAccessToken"]
    );
  },
  computed: {
    ...mapFields("profile", [
      "name",
      "surname",
      "email",
      "address_country",
      "avatar",
    ]),
  },
  methods: {
    /*
            ╔═╗╦  ╦  ╔═╗╦═╗╔═╗╦╔═╗╔═╗
            ╠═╣║  ║  ║╣ ╠╦╝║ ╦║║╣ ╚═╗
            ╩ ╩╩═╝╩═╝╚═╝╩╚═╚═╝╩╚═╝╚═╝
        */
    searchAllergy(event) {
      console.log("searchAllergy");
      this.allergyFilteredIngredients = this.ingredients.filter(
        (ingredient) => {
          return (
            ingredient.name.toLowerCase().indexOf(event.query.toLowerCase()) ==
            0
          );
        }
      );

      console.log(this.allergyFilteredIngredients);
    },
    /*
            ╔═╗╔═╗╔╦╗╦╦ ╦ ╦  ╔╦╗╔═╗╔╦╗╔╗ ╔═╗╦═╗
            ╠╣ ╠═╣║║║║║ ╚╦╝  ║║║║╣ ║║║╠╩╗║╣ ╠╦╝
            ╚  ╩ ╩╩ ╩╩╩═╝╩   ╩ ╩╚═╝╩ ╩╚═╝╚═╝╩╚═

        */
    addFamilyMember() {
      this.$store.commit("familyMember/clear");
      this.displayFamily = true;
    },
    editFamilyMember(id) {
      this.$store.dispatch("familyMember/load", id);
      this.displayFamily = true;
    },
    removeFamilyMember(id) {
      this.$confirm.require({
        span: this.$t("confirm.delete"),
        header: this.$t("confirm.delete_title"),
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          //callback to execute when user confirms the action
          this.$store.dispatch("familyMember/remove", id);
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
        onHide: () => {
          //Callback to execute when dialog is hidden
        },
      });
    },

    save() {
      if (this.v$.$invalid) {
        return;
      }
      this.$store.dispatch("profile/update").then(
        () => {
          nextTick(() => {
            this.displayFamily = false;
          });
          this.$store.commit("profile/updateNameBackup", this.name);
          this.$store.commit("profile/updateSurnameBackup", this.surname);
          this.$toast.add({
            severity: "success",
            summary: "",
            detail: this.$t("toast.success"),
            life: 3000,
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
  components: {
    ProfileSidebox,
    FamilyMemberForm,
    ProfiloIntolleranze,
  },
};
</script>

<style scoped lang="scss">
.family-member {
  width: 100%;
  max-width: 300px;
  height: 52px;
  left: 314px;
  top: 768px;
  /* Neutral/Grey Background */
  background: #fafafa;
  border-radius: 100px;
  padding: 0 20px;
  margin: 10px;
}

.rectangular {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #363b3f;
  background-color: #fafafa;
  padding: 4px 4px;
  margin: 0 20px;
  border-radius: 10px;
  border: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

h1 {
  margin: 0;
  margin-top: 20px;
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
}

h3 {
  margin: 0;
  margin-top: 0px;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */
  /* Neutral/Grey */
  color: #98999a;
}

p {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.user-info {
  margin-left: 151px;
}

.header {
  position: relative;
  width: 100%;
  height: 164px;
  left: 09px;
  top: 0px;
  background: #004e59;
  mix-blend-mode: normal;
  border-radius: 10px;
}
</style>

<style lang="scss">
.profile-avatar {
  position: absolute;
  width: 115px;
  height: 115px;
  left: 20px;
  top: 100px;
  border-radius: 50%;
  img {
    border-radius: 50%;
    overflow: hidden;
    transform: translate(50%, 50%) scale(1.8);
  }
}
</style>
